module.exports = __webpack_public_path__ + "static/media/Notification_Information.81f0acd5.svg";